module.exports = __webpack_public_path__ + "static/img/花瓶2.28a8ed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/花瓶2.png
// module id = Xl8n
// module chunks = 2